import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { usePackages } from "../../admin/packages/usePackages";

export function PackageInfo(props: { packageId: string }) {
  const { packages, isLoading } = usePackages();
  const selectedPackage = packages?.find((p) => p.id.id === props.packageId);
  const name = selectedPackage?.name.value ?? "-";
  const packageInfo = selectedPackage?.note;
  if (isLoading) {
    return null;
  }
  return (
    <>
      <Stack direction="row" spacing={1} sx={{ mt: 3, alignItems: "center" }}>
        <Typography
          sx={{
            fontWeight: 700,
          }}
        >
          Kalkulacja na podstawie pakietu:
        </Typography>

        <Typography>{name}</Typography>
      </Stack>
      {packageInfo && (
        <Box
          sx={{
            p: 2,
            mt: 3,
            bgcolor: "rgba(13, 110, 253, 0.04)",
            borderRadius: 1,
            border: "1px solid rgba(13, 110, 253, 0.1)",
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{
              alignItems: "flex-start",
            }}
          >
            <InfoOutlinedIcon color="primary" fontSize="small" sx={{ mt: 0.3 }} />
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
              }}
            >
              <strong>Informacja z pakietu:</strong> {packageInfo}
            </Typography>
          </Stack>
        </Box>
      )}
    </>
  );
}
